export default class CallUs {
    openLocationSelector = false;
}

document.addEventListener('alpine:init', () => {
    Alpine.data('callUs', () => new CallUs());
});